export async function tryCatch<T>(promise: Promise<T>): Promise<[undefined, T] | [Error]> {
  try {
    const data = await promise;
    return [undefined, data] as [undefined, T];
  } catch (error) {
    let err = error;
    if (err === undefined || !(err instanceof Error)) {
      err = new Error();
    }

    return [err as Error];
  }
}
